module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_gc_nor@2x.96371792.png";